<template>
  <div class='main'>
    <component v-if="templateType" :is="templateType === 1 ? 'DefaultTemplate' : 'RankTemplate'" :ranking-details="rankingDetails" />
  </div>
</template>

<script>
import DefaultTemplate from '../components/DefaultTemplate.vue'
import RankTemplate from '../components/RankTemplate.vue'
import { getRankingDetail } from '@/api'
import getUrlParams from '@/utils/getUrlParams'
import { isWeChat, isNfPlus, isAndroid } from '@/utils/env'
import loadjs from 'loadjs'
import { WX_JSAPI_URL } from '@/utils/constants'
import initWxShare from '@/utils/wx'

export default {
  name: 'Home',
  components: {
    DefaultTemplate,
    RankTemplate,
  },
  data () {
    return {
      templateType: null,
      shareConfig: {
        title: '排行榜',
        desc: '排行榜',
        link: window.location.href.split('#')[0],
        imgUrl: window.location.origin + window.location.pathname.split('/').slice(0, -1).join('/') + '/share.png',
      },
      rankingDetails: {},
    }
  },
  computed: {
    rankId () {
      const { id } = getUrlParams()
      return id
    },
  },
  async created () {
    await this.fetchDetail()
    await this.initShare()
  },
  mounted () {
  },
  methods: {
    async initShare () {
      // 微信分享
      if (isWeChat()) {
        await loadjs(WX_JSAPI_URL, () => {
          initWxShare(this.shareConfig)
        })
      }
      // 端内分享
      if (isNfPlus() && window.nfplusJsbridge.updateAppMessageShareData) {
        console.log('端内分享')
        const options = {
          desc: this.shareConfig.desc,
          title: this.shareConfig.title,
          imgUrl: this.shareConfig.imgUrl,
          link: window.location.href,
        }
        if (isAndroid()) {
          options.title = encodeURIComponent(options.title)
          options.desc = encodeURIComponent(options.desc)
        }
        try {
          window.nfplusJsbridge.updateAppMessageShareData(options)
        } catch (error) {
          console.log('端内分享失败', error)
        }
      }
      if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge?.invoke === 'function') {
        this.handleFontSize()
      } else {
        document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false)
      }
    },
    handleFontSize () {
      window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      window.WeixinJSBridge.on('menu:setfont', function () {
        window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      })
    },
    fetchDetail () {
      return getRankingDetail(this.rankId).then(res => {
        this.templateType = res.data.templateType || 1
        this.rankingDetails = res.data
        document.title = res.data.title
        this.shareConfig.title = res.data.shareTitle
        this.shareConfig.desc = res.data.shareIntroduction
        this.shareConfig.imgUrl = res.data.shareIcon
      })
    },
  },
}
</script>
<style lang="less" scoped>
.footer{
  padding: 0.1rem 0 0.34rem;
  font-size: 0.12rem;
  color: rgba(0,0,0,0.30);
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
</style>
